import { BiRefresh } from 'react-icons/bi';
import Button from 'react-bootstrap/Button';

export function RefreshButton({ children, ...rest }) {
    return (
        <Button variant="outline-primary" size="sm" {...rest}>
          <BiRefresh/>
          {children}
        </Button>
    );
}
